import { useEffect, useRef, useState } from 'react';

// Redux & Action
import { useDispatch, useSelector } from 'react-redux';
import { setSelectCamp } from "@core/redux/actions/camp/index";
// import { setScrollStatus } from "@core/redux/actions/game/index";

// Component
import { Grid } from '@mui/material';
import ImageShow from "views/components/ImageShow";
import GameList from "views/components/Game/GameList";
import SearchButton from "views/components/SearchButton";

export default function MenuGameContent({ campSlot, selectCampData, dataMenu, loadGameData, gotoScroll, isLargeScreen }) {
    const dispatch = useDispatch();
    const scrollStatus = useSelector(state => state.reduxGame.scrollStatus);
    const gridRef = useRef();
    const [gridWidth, setGridWidth] = useState(0);
    const [checkScroll, setCheckScroll] = useState(false);

    const selectDataCamp = (data) => {
        dispatch(setSelectCamp(data));
        // dispatch(setScrollStatus(false));
        gotoScroll();
    };

    useEffect(() => {
        if (selectCampData === null) {
            if (campSlot.length > 0) {
                dispatch(setSelectCamp(campSlot[0].code));
                // loadGameData(campSlot[0].code, dataMenu.gameCampType, "", 12, 0, false, true, null);
            }
        }
        else {
            loadGameData(selectCampData, dataMenu.gameCampType, "", 15, 0, false, true, null);
        }
    }, [selectCampData, campSlot]);

    useEffect(() => {
        if (isLargeScreen === false) {
            if (gridRef?.current?.offsetWidth !== undefined) {
                setGridWidth(gridRef?.current?.offsetWidth);
            }
        }
    }, [gridRef?.current?.offsetWidth]);

    useEffect(() => {
        if (isLargeScreen === false) {
            if (scrollStatus) {
                setCheckScroll(scrollStatus);
            }
            else {
                setCheckScroll(false);
            }
        }
    }, [scrollStatus, isLargeScreen]);

    return (
        <>
            <Grid container spacing={isLargeScreen ? 2 : 1}>
                <Grid item className="gameColumnLeft" ref={gridRef}>
                    {
                        isLargeScreen ?
                            campSlot.map((item, index) => (
                                <div key={index} className={["campListMenu center cursorPointer", index === 0 ? "campListMenuRadiusTop" : "", index === (campSlot.length - 1) ? "campListMenuRadiusBottom" : "", selectCampData === item.code ? "campListMenuActive" : ""].join(" ")} onClick={() => selectDataCamp(item.code)}>
                                    <ImageShow className="imgCamp" src={item.logo} alt="Logo ค่ายเกม สล็อตออนไลน์" />
                                </div>
                            ))
                            :
                            gridWidth !== 0 && (
                                <div className={checkScroll ? "positionFixed campMenuFixed" : ""} style={{ width: checkScroll ? `${gridWidth - 8}px` : "" }}>
                                    {
                                        campSlot.map((item, index) => (
                                            <div key={index} className={["campListMenu center cursorPointer", index === 0 ? "campListMenuRadiusTop" : "", index === (campSlot.length - 1) ? "campListMenuRadiusBottom" : "", selectCampData === item.code ? "campListMenuActive" : ""].join(" ")} onClick={() => selectDataCamp(item.code)}>
                                                <ImageShow className="imgCamp" src={item.logo} alt="Logo ค่ายเกม สล็อตออนไลน์" />
                                            </div>
                                        ))
                                    }
                                </div>
                            )
                    }
                </Grid>
                <Grid item className="gameColumnRight">
                    <Grid container direction="row" spacing={1} justifyContent="space-between">
                        <Grid item>
                            <div className="campListMenuTitle textBoldHight">
                                {
                                    `เกมสล็อตยอดนิยมค่าย ${selectCampData}`
                                }
                            </div>
                        </Grid>
                        <Grid item>
                            <SearchButton></SearchButton>
                        </Grid>
                    </Grid>

                    <div className="contentMediumMarginTop">
                        <GameList selectCamp={selectCampData}></GameList>
                    </div>
                </Grid>
            </Grid>
        </>
    );
}